import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TabPane, Col, Row, Card, CardBody, CardTitle, Button, Spinner } from 'reactstrap';
import moment from 'moment';

import BZAPIService from '../../../services/BZAPIService';
import ServiceWidget from '../../dashboard/ServiceWidget';
import CardSummary from '../Vendor/CardSummary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import { isEmpty } from 'lodash';
import Loader from '../../common/Loader';

import { VendorsContext } from '../../../context/VendorsContext';
import { DashboardContext } from '../../../context/DashboardContext';

export default function TabOne({
  vendorId,
  vendorLabel,
  activeTab,
  setActiveTab,
  snIntegrationCheck,
  isConfigured,
  modalOpen,
  setModalOpen,
  setIsForceRun,
  timeUnit,
  setTimeUnit,
  timeValue,
  setTimeValue,
  loading,
  isServiceActive,
  setIsServiceActive
}) {
  const [priorityStats, setPriorityStats] = useState();
  const [nextRun, setNextRun] = useState();
  const [isLoading, setLoading] = useState(true);
  const [vendorApiStatus, setVendorApiStatus] = useState();

  // eslint-disable-next-line
  const [vendors, setVendors] = useContext(VendorsContext);
  const [dashboard, setDashboard] = useContext(DashboardContext);

  const selectStyles = {
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: isFocused ? 'white' : isSelected ? 'white' : 'black'
      };
    }
  };
  const timeUnitOptions = [{ label: 'Minutes', value: 'minute' }, { label: 'Hours', value: 'hour' }];
  const mins = [
    { label: '15', value: '15' },
    { label: '30', value: '30' },
    { label: '45', value: '45' },
    { label: '60', value: '60' }
  ];

  const hrs = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
    { label: '7', value: 7 },
    { label: '8', value: 8 },
    { label: '9', value: 9 },
    { label: '10', value: 10 },
    { label: '11', value: 11 },
    { label: '12', value: 12 },
    { label: '13', value: 13 },
    { label: '14', value: 14 },
    { label: '15', value: 15 },
    { label: '16', value: 16 },
    { label: '17', value: 17 },
    { label: '18', value: 18 },
    { label: '19', value: 19 },
    { label: '20', value: 20 },
    { label: '21', value: 21 },
    { label: '22', value: 22 },
    { label: '23', value: 23 },
    { label: '24', value: 24 }
  ];

  async function getScheduleSettings() {
    try {
      const res = await BZAPIService.getBugServiceSchedule(vendorId);
      setTimeUnit(
        res?.data?.timeUnit?.length
          ? res?.data?.timeUnit
          : vendorId === 'aws' || vendorId === 'azure' || vendorId === 'msft365'
          ? 'minute'
          : 'hour'
      );
      const val = res?.data?.number;
      setTimeValue(
        val
          ? { label: val, value: val }
          : vendorId === 'aws' || vendorId === 'azure' || vendorId === 'msft365'
          ? mins[1]
          : hrs[3]
      );
      setNextRun(res?.data?.nextRunUTC);
    } catch (e) {
      console.log(e);
      setTimeValue(vendorId === 'aws' || vendorId === 'azure' || vendorId === 'msft365' ? mins[1] : hrs[3]);
      setTimeUnit(vendorId === 'aws' || vendorId === 'azure' || vendorId === 'msft365' ? 'minute' : 'hour');
      setLoading(false);
    }
  }

  function forceRun() {
    setModalOpen(!modalOpen);
    setIsForceRun(true);
  }

  function buildVendorStat(dataSet, colors, activeVendors) {
    const vendorPriorityStats = {};
    activeVendors?.map(vendor => {
      vendorPriorityStats[vendor.id] = [];

      return vendorPriorityStats;
    });

    dataSet?.map((bugPriority, id) => {
      if (!vendorPriorityStats[bugPriority.vendorId]) vendorPriorityStats[bugPriority.vendorId] = [];
      const colorIndex = vendorPriorityStats[bugPriority.vendorId].length;

      const vendorPriorityStat = {
        id,
        value: bugPriority.priorityCount,
        name: bugPriority.priority,
        color: bugPriority.priority === 'Unspecified' ? '#90919a' : colors[colorIndex]
      };
      vendorPriorityStats[bugPriority.vendorId].push(vendorPriorityStat);
    });
    return vendorPriorityStats;
  }

  async function updateServices() {
    try {
      setLoading(true);
      const dash = await BZAPIService.getDashboard();
      // Setup vendor priority stats
      setDashboard(dash);
      const colors = [
        '#ff475f',
        '#000000',
        '#961ca2',
        '#35bc8e',
        '#90919a',
        '#c1bdb7',
        '#B54E34',
        '#253544',
        '#48384B',
        '#816577',
        '#445A57',
        '#617E71',
        '#829A92',
        '#567387',
        '#8096A8',
        '#816477'
      ];
      const bugsLastWeek = buildVendorStat(dash?.bugsLastWeek, colors, vendors);
      setPriorityStats(bugsLastWeek);
      setLoading(false);
      // console.log('dash', dash);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }

  async function getVendorHealthStatus() {
    if (vendorId === 'aws') {
      try {
        const res = await BZAPIService.getAwsHealthCheck(vendorId);
        console.log(res);
        setVendorApiStatus(res);
      } catch (e) {
        console.log(e);
      }
    }
    if (vendorId === 'azure') {
      try {
        const res = await BZAPIService.getAzureHealthCheck(vendorId);
        console.log(res);
        setVendorApiStatus(res);
      } catch (e) {
        console.log(e);
      }
    }
    if (vendorId?.includes('msft')) {
      try {
        const res = await BZAPIService.getMsftHealthCheck(vendorId);
        // console.log(res);
        setVendorApiStatus(res);
      } catch (e) {
        console.log(e);
      }
    }
    if (vendors?.filter(v => v?.id === vendorId && v?.vendorData?.statusIo === true)?.length) {
      try {
        const res = await BZAPIService.getVendorHealthCheck(vendorId);
        setVendorApiStatus(res);
      } catch (e) {
        console.log(e);
      }
    }
  }

  useEffect(() => {
    setLoading(true);

    if (vendors?.length) {
      // Check for 3rd party API health
      getVendorHealthStatus();
      // Get fresh stats
      updateServices();
    }
    // eslint-disable-next-line
  }, [vendorId, activeTab, vendors]);

  useEffect(() => {
    // Check for service schedule settings
    getScheduleSettings();
    // eslint-disable-next-line
  }, [vendorId, vendors]);

  return (
    <div style={{ minWidth: '100%' }}>
      <TabPane tabId="1">
        {activeTab === '1' && (
          <Card className="mb-4">
            <CardBody>
              <div className="row">
                <div className="col text-right ">
                  <a
                    href={`${
                      vendorId === 'postgre'
                        ? '/documentation/vendor-configuration-guides/'
                        : vendorId === 'msftaccess'
                        ? '/documentation/vendor-configuration-guides/'
                        : vendorId === 'msftsql'
                        ? '/documentation/vendor-configuration-guides/'
                        : vendorId === 'msftserver'
                        ? '/documentation/vendor-configuration-guides/microsoft-integration-guide'
                        : vendorId === 'msft'
                        ? `/documentation/vendor-configuration-guides/microsoft-integration-guide`
                        : vendorId === 'msft365'
                        ? `/documentation/vendor-configuration-guides/microsoft365-integration-guide`
                        : vendorId === 'rh'
                        ? `/documentation/vendor-configuration-guides/red-hat-integration-guide`
                        : `/documentation/vendor-configuration-guides/${vendorId}-integration-guide`
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-falcon-default mb-2 btn-sm"
                  >
                    <FontAwesomeIcon icon="book" className="mr-2" />
                    Integration Guide
                  </a>
                </div>
              </div>

              {loading ? (
                <Loader />
              ) : !snIntegrationCheck && !loading ? (
                <>
                  <p className="text-center">Please setup your ServiceNow integration.</p>
                  <div className="text-center">
                    <Link className="btn btn-falcon-primary text-center" to="/integrations/servicenow">
                      Setup now
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  <Row>
                    <Col>
                      {dashboard?.services?.map(service => {
                        let color = 'warning';
                        switch (service.status) {
                          case 'OPERATIONAL':
                            color = 'green';
                            break;
                          case 'NOT CONFIGURED':
                          case 'PENDING':
                            color = 'blue';
                            break;
                          case 'ERROR':
                            color = 'red';
                            break;
                          case 'RUNNING':
                            color = 'light-blue';
                            break;
                          default:
                            break;
                        }
                        return service?.id === vendorId + '-bs' ? (
                          <CardSummary
                            key={service?.name}
                            title={service?.status}
                            color={color}
                            linkText="View"
                            to={service?.vendorId}
                            message={service?.message}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            errors={service?.vendorData?.errors}
                            timestamp={service?.vendorData?.timestamp}
                            loadServices={updateServices}
                            loading={isLoading}
                            vendorId={vendorId}
                            isConfigured={isConfigured}
                            isServiceActive={isServiceActive}
                            setIsServiceActive={setIsServiceActive}
                          >
                            {service?.name?.replace('Systems', 'Networks')}
                          </CardSummary>
                        ) : (
                          ''
                        );
                      })}
                    </Col>
                    <Col>
                      {vendors?.map((vendor, key) => {
                        return vendor.id === vendorId ? (
                          <div key={key} className="mb-3 ">
                            <ServiceWidget
                              data={!isEmpty(priorityStats) ? priorityStats[vendor.id] : []}
                              loading={isLoading}
                              title={
                                'Bugs found in the last 7 days for ' + vendor?.name?.replace('Systems', 'Networks')
                              }
                            />
                          </div>
                        ) : (
                          ''
                        );
                      })}
                    </Col>
                  </Row>
                  <Row xs={'2'}>
                    <Col>
                      <Card className="mb-3 overflow-hidden" style={{ minWidth: '24rem', minHeight: '11rem' }}>
                        <CardBody className="position-relative">
                          <Row>
                            <Col>
                              <h6>Vendor API status</h6>
                            </Col>
                            <Col className="text-right d-inline-flex justify-content-end">
                              <p className="small">
                                <span className="fa-stack fa-xs mr-1">
                                  <FontAwesomeIcon
                                    icon="circle"
                                    className={`branding-${
                                      !vendorApiStatus?.service_issues ? 'green' : 'red'
                                    } fa-stack-2x`}
                                  />
                                  <FontAwesomeIcon
                                    icon={!vendorApiStatus?.service_issues ? 'check' : 'exclamation'}
                                    className="fa-stack-1x"
                                    inverse
                                  />
                                </span>
                              </p>
                              <p className={`branding-${!vendorApiStatus?.service_issues ? 'green' : 'red'} small`}>
                                <span className="pb-2">
                                  {!vendorApiStatus?.service_issues ? 'OPERATIONAL' : 'ERRORS'}
                                </span>
                              </p>
                            </Col>
                          </Row>

                          {/* <div>
                            {vendorApiStatus?.length ? (
                              <div className="active mt-2">
                                <List type="unstyled">
                                  {vendorApiStatus.map(e => (
                                    <li key={e.label}>
                                      <small className="active">
                                        {e.label} - {e.value}
                                      </small>
                                    </li>
                                  ))}
                                </List>
                              </div>
                            ) : (
                              ''
                            )}
                          </div> */}
                        </CardBody>
                      </Card>
                    </Col>
                    <Col>
                      <Card className="mb-3 overflow-hidden" style={{ minWidth: '24rem', minHeight: '8rem' }}>
                        {/* <Background className={`bg-card`} /> */}
                        <CardBody className="position-relative">
                          <Row>
                            <Col>
                              <h6>
                                Configure bug service run frequency (
                                {vendorId === 'aws' || vendorId === 'azure' || vendorId === 'msft365'
                                  ? 'in minutes'
                                  : 'in hours'}
                                )
                              </h6>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-block">
                              <div className="row">
                                <Select
                                  options={timeUnitOptions}
                                  value={timeUnitOptions.find(el => el.value === timeUnit)}
                                  onChange={e => {
                                    // reset time value to a sane default
                                    if (e.value === 'minute') setTimeValue(mins[1]);
                                    else setTimeValue(hrs[3]);

                                    setTimeUnit(e.value);
                                  }}
                                  styles={selectStyles}
                                  theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                      ...theme.colors,
                                      primary25: '#253746',
                                      primary: '#bd472a'
                                    },
                                    width: '200px'
                                  })}
                                  className="col-4 inline basic-multi-select"
                                />
                                <Select
                                  options={timeUnit === 'minute' ? mins : hrs}
                                  value={timeValue}
                                  placeholder={'Select frequency'}
                                  onChange={e => setTimeValue(e)}
                                  menuPortalTarget={document.body}
                                  // styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                  theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                      ...theme.colors,
                                      primary25: '#253746',
                                      primary: '#bd472a'
                                    }
                                  })}
                                  styles={selectStyles}
                                  className="col-8 pl-0 basic-multi-select"
                                />
                              </div>
                              <div className="text-right">
                                <Button
                                  color="falcon-default"
                                  className="mt-2"
                                  size="sm"
                                  onClick={() => forceRun()}
                                  disabled={!isConfigured}
                                  // onClick={() => setBugServiceFrequency()}
                                >
                                  Save &amp; Run now
                                </Button>
                              </div>
                              {nextRun?.length ? (
                                <small className="mt-2">
                                  {'Next run: ' +
                                    moment
                                      .utc(nextRun)
                                      .local()
                                      .format('MMMM Do YYYY, h:mm a')}
                                </small>
                              ) : (
                                <Spinner size={'sm'} />
                              )}
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col />
                  </Row>
                </>
              )}
            </CardBody>
          </Card>
        )}
      </TabPane>
    </div>
  );
}

TabOne.propTypes = {
  vendorId: PropTypes.string,
  vendorLabel: PropTypes.string,
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  snIntegrationCheck: PropTypes.bool,
  services: PropTypes.array,
  activeVendors: PropTypes.array,
  priorityStats: PropTypes.object,
  isConfigured: PropTypes.bool,
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  setIsForceRun: PropTypes.func,
  timeUnit: PropTypes.string,
  setTimeUnit: PropTypes.func,
  timeValue: PropTypes.object,
  setTimeValue: PropTypes.func,
  nextRun: PropTypes.string,
  setNextRun: PropTypes.func,
  loading: PropTypes.bool,
  setIsServiceActive: PropTypes.func,
  isServiceActive: PropTypes.number
};
